import {
  createRescueDecisionRequestSchema, getRescueDecisionResponseSchema,
  respondRescueDecisionRequestSchema, rescueDecisionResponseSchema, rescueDecisionErrorResponseSchema,
  type RespondRescueDecisionRequest,
} from "@io-spoke/contracts/rescue";
import { getApiClient } from "./apiClient";

export class RescueDecisionConflict extends Error {}
const decisionPath = (caseId: string) => `/rescues/${encodeURIComponent(caseId)}/decision`;
const acceptDecisionResponse = { validateStatus: (status: number) => status === 409 || (status >= 200 && status < 300) };

function parseMutation(response: { status: number; data: unknown }) {
  if (response.status === 409) {
    const error = rescueDecisionErrorResponseSchema.safeParse(response.data);
    throw new RescueDecisionConflict(error.success ? error.data.error : "This decision changed. Review its latest status.");
  }
  const parsed = rescueDecisionResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("The recovery decision returned an invalid response.");
  return parsed.data.decision;
}

export async function getRescueDecision(caseId: string) {
  const response = await getApiClient().get(decisionPath(caseId));
  const parsed = getRescueDecisionResponseSchema.safeParse(response.data);
  if (!parsed.success) throw new Error("The saved recovery decision returned an invalid response.");
  return parsed.data.decision;
}

export async function prepareRescueDecision(caseId: string) {
  const payload = createRescueDecisionRequestSchema.parse({});
  return parseMutation(await getApiClient().post(decisionPath(caseId), payload, acceptDecisionResponse));
}

export async function respondRescueDecision(caseId: string, decisionId: string, input: RespondRescueDecisionRequest) {
  const payload = respondRescueDecisionRequestSchema.parse(input);
  return parseMutation(await getApiClient().post(`${decisionPath(caseId)}/${encodeURIComponent(decisionId)}/respond`, payload, acceptDecisionResponse));
}
